import {EVENT_PRICE} from "@COMPONENTS/common/constants";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventPrice {
	adtPrice: number;
	chdPrice: number;
	infPrice: number;
	bafAdtCost: number;
	bafChdCost: number;
	bafInfCost: number;
	airTaxAdtCost: number;
	airTaxChdCost: number;
	airTaxInfCost: number;
	expCurrCd: string;
	guideExpAmt: number;
	driverAmt: number;
	depositDivi: string /* 예약금 구분 */;
	depositDiviNm: string /* 예약금 구분명 */;
	depositAmt: number /* 예약금 금액 */;
}

/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event/{evCd}/price`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventPrice";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event/${evCd}/price`;
};

/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event/{evCd}/price`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const eventPriceAsync = (evCd: string) =>
	useConfigureAxios(getPath(evCd), {
		method: "GET",
	});

/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event/{evCd}/price`
 * parameter
 *   `evCd` 행사코드
 * ```*/

const useEventPrice = (evCd: string, options?: Partial<UseQueryOptions<Response<EventPrice>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
		placeholderData: {body: EVENT_PRICE},
	});

export default useEventPrice;
export {eventPriceAsync, getPath, key};
export type {EventPrice};
